<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add Variant Orders/Receipt
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <template>
      <v-card>
        <v-card-title>
          <span class="body-1 font-weight-bold"
            >Add<i class="caption red--text ml-4"> * required field</i></span
          >
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row class="text-center py-0">
              <v-col
                cols="12"
                sm="6"
                class="pb-0"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
              >
                <v-autocomplete
                  v-model="client"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  class="required pb-0"
                  @focus="fetchClientList"
                  @input="fetchReceipts"
                  :rules="[(v) => !!v || 'Client is required.']"
                  outlined
                  :readonly="$route.params.id > 0"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  :readonly="$route.params.id > 0"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  v-model="receipt"
                  :items="parent_receipt_nos"
                  item-text="receipt_key"
                  item-value="id"
                  label="Select Receipt Number"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'Receipt is required.']"
                  :readonly="$route.params.id > 0"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  class="pb-0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(date)"
                      label="Received Date"
                      append-icon="mdi-calendar"
                      readonly
                      class="required pb-0"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      :rules="[(v) => !!v || 'Date is required.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  v-model="received_by"
                  label="Received By"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'Received By is required.']"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" class="pb-0">
                <v-file-input
                  v-model="file"
                  label="Upload File"
                  clearable
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  accept=".xlsx"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'File is required.']"
                  outlined
                  @click="file = null"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <div class="text-left">
              <v-btn color="green" dark class="mr-3 mt-2" @click="listPage">
                Uploaded List
              </v-btn>
              <v-btn
                class="primary mt-2"
                @click="saveForm()"
                :loading="uploadOrder"
                >Submit</v-btn
              >

              <v-btn
                color="info"
                class="mt-2 ml-2"
                :loading="downloader"
                @click="downloadTemplate()"
                >Download template</v-btn
              >
              <v-btn color="white" class="mt-2 ml-4" @click="reset()"
                >Cancel</v-btn
              >
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },

    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3 &&
          this.userCategory.user_category !== 6
          ? i.value !== "client"
          : true;
      });
    },
  },
  data: () => ({
    timelinePopup: false,
    parent_receipt_nos: [],
    parent_receipt_no: null,
    receipt_key: null,
    receipt_no: null,
    receipt: null,
    receipts: [],
    received_by: null,
    date: new Date().toISOString().split("T")[0],
    dateMenu: false,
    adddialog: false,
    openMessage: false,
    detailsData: [],
    tableDetailsItems: [],

    totalDetails: 0,
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    dialogItem: false,
    listloader: false,
    iconLoader: false,
    isloading: false,
    carriers: [],
    isTableloading: false,
    itemCalled: false,
    sku: null,
    client: null,
    loading: false,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    categories: [],
    categoryLoader: false,
    category: "",
    downloader: false,
    dialog: false,
    file: null,
    selectedClient: "",
    fileLoader: false,
    statusList: [],
    vendorInvoiceNumber: "",
    selectedStatus: "",

    tableData: [],
    totals: 0,
    syncButton: false,
    expand: [],
    purchase_order_code: "",
    vendor_code: "",
    expanded: [],
    tableDataItems: [],
    selectedGrn: "",
    expandedRow: null,
    itemFound: {},
    downloaderRow: false,
    selectedItem: {},
    subheader: [
      {
        text: "Sku",
        value: "sku",
        width: "200",
      },
      {
        text: "Quantity",
        value: "quantity",
        width: "100",
      },
      {
        text: "Pending Quantity",
        value: "pending_quantity",
        width: "100",
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity",
        width: "100",
      },
    ],
    stores: [],
    infor_storer_id: null,
    uploadOrder: false,
  }),

  created() {
    this.fetchClientList();
    if (this.userCategory.user_category == 1) {
      this.client = this.$store.getters.user.id;
      this.fetchReceipts();
    }
    if (this.$route.params.id > 0) {
      this.getinboundvariantDetails(this.$route.params.id).then((res) => {
        this.client = res.data[0].client_id_id;
        this.fetchClientList();
        this.fetchReceipts(res.data[0].client_id_id);
        this.receipt = res.data[0].parent_inbound_id;
        this.infor_storer_id = res.data[0].channel_id_id;
      });
    }
  },
  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "fetchClient",
      "getItemDetails",
      "getReceiptNumber",
      "uploadReceipt",
      "getInforStoreList",
      "getChannelDropdownBB",
      "downloadVariantTemplate",
      "getinboundvariantDetails",
    ]),
    saveForm() {
      if (this.$refs.form.validate()) {
        this.uploadOrder = true;
        let formData = new FormData();
        formData.append("client_id", this.client);
        formData.append("data_file", this.file);
        formData.append("date_and_time", this.date);
        formData.append("receipt_number", this.receipt);
        formData.append("received_by", this.received_by);
        formData.append("storer_id", this.infor_storer_id);

        this.uploadReceipt(formData)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push({ name: "InboundSummary" });
            this.uploadOrder = false;
          })
          .catch(() => {
            this.uploadOrder = false;
          });
      }
    },
    reset() {
      this.$router.push({ name: "InboundSummary" });
    },
    fetchReceipts() {
      if (this.client) {
        let payload = {
          client_id: this.client,
        };
        this.getReceiptNumber(payload).then((res) => {
          this.parent_receipt_nos = res.data;
        });
        this.getStores(this.client);
      }
    },

    downloadTemplate() {
      this.downloader = true;
      this.downloadVariantTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    clearDateInput(from) {
      if (from == "from_date") {
        this.from_date = null;
      } else {
        this.to_date = null;
      }
    },
    listPage() {
      this.$router.push({
        name: "skuvariantStatusList",
        params: {
          type: "inbound_variant_upload",
        },
      });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          variant: "1",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores(id) {
      this.getChannelDropdownBB(id).then((res) => {
        this.stores = res.data;
      });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient.id);
      }
      this.uploadSku(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.dialog = false;
          this.fileLoader = false;
          this.$router.push("inboundSummary");
        })
        .catch(() => {
          this.dialog = false;
          this.$refs.form.reset();
          this.fileLoader = false;
        });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
</style>
